import { render, staticRenderFns } from "./BackupCodesMethodInstructions.vue?vue&type=template&id=6b94ca00&scoped=true"
import script from "./BackupCodesMethodInstructions.vue?vue&type=script&lang=js"
export * from "./BackupCodesMethodInstructions.vue?vue&type=script&lang=js"
import style0 from "./BackupCodesMethodInstructions.vue?vue&type=style&index=0&id=6b94ca00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94ca00",
  null
  
)

export default component.exports